module.exports = __webpack_public_path__ + "static/media/10_tn.9ce34d13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/10_tn.jpg
// module id = 224
// module chunks = 0